import { StyleSheet, Platform } from "react-native";
import AppTheme from "../../AppTheme";

const integrationStyles = StyleSheet.create({
  container: {
    minHeight: 40,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 14,
  },
  highlight: {
    backgroundColor: "#F8E585",
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    //flex: 1,
  },
  main: {
    //flex: 1,
    height: 36,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  integrationName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
  },
  detailsContainer: {
    paddingLeft: 28,
    paddingRight: 20,
  },
  tabName: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12, 
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  tabSeparator: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    paddingHorizontal: 4,
  },
  pipe: {
    paddingHorizontal: 4,
  },

  listHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    marginLeft: 9,
    paddingRight: 0,
    height: 40,
  },
  listHeaderText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    flex: 1,
  },
  flatList: {
    paddingTop: 8,
    paddingHorizontal: 0,
    flexGrow: 0,
    paddingBottom: 300,
  },
  list: {
    paddingTop: 8,
    borderTopRightRadius: 4,
    borderTopLeftRadius: 4,
    shadowOpacity: 0.05,
    shadowOffset: { width: 0, height: -2 },
    shadowColor: "#000",
    shadowRadius: 3,
    elevation: 5,
    borderRadius: 4,
  },
  submitButton: {
    height: 32,
    width: "50%",
    marginTop: 11,
  },
  submitButtonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  placeholder: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: 36,
    borderWidth: 1,
    borderColor: "#ABADB3",
    borderStyle: "dashed",
    borderRadius: 4,
  },
  placeholderText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#ABADB3",
  },
});

export default integrationStyles;
